var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_113173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 13.39H32.5001",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "#00000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.39H14.21",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3604 20.02H32.5004",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.02H24.45",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0303 26.65H32.5003",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 26.65H16.13",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1197 13.35C18.1197 12.27 17.2497 11.4 16.1697 11.4C15.0897 11.4 14.2197 12.28 14.2197 13.35C14.2197 14.42 15.0897 15.3 16.1697 15.3C17.2497 15.3 18.1197 14.42 18.1197 13.35Z",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.41 18.07C25.33 18.07 24.46 18.95 24.46 20.02C24.46 21.09 25.33 21.97 26.41 21.97C27.49 21.97 28.36 21.09 28.36 20.02C28.36 18.95 27.49 18.07 26.41 18.07Z",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0799 24.7C16.9999 24.7 16.1299 25.58 16.1299 26.65C16.1299 27.72 16.9999 28.6 18.0799 28.6C19.1599 28.6 20.0299 27.72 20.0299 26.65C20.0299 25.58 19.1599 24.7 18.0799 24.7Z",
    stroke: "#002554",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_113173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlign);
export default __webpack_public_path__ + "static/media/Align.a16defc10ef4aa136a3976c2ae0efaec.svg";
export { ForwardRef as ReactComponent };